import React, { useRef } from "react";
import { generatePath, Link, useLocation } from "react-router-dom";

import { useResizeObserver } from "@/hooks/useResizeObserver";

import { ACCOUNT_ROUTES } from "../../pages";

function AddRowRightGap() {
  return (
    <div className="tw-sticky tw-right-0 tw-top-9 tw-z-10 tw-bg-neutral-25" />
  );
}

export function TableAddRow({
  hasActions,
  children,
  fullTableWidth,
  rightGap,
}: {
  hasActions: boolean;
  children: React.ReactNode;
  fullTableWidth?: number;
  rightGap: number;
}) {
  const { pathname } = useLocation();
  const ref = useRef<HTMLAnchorElement>(null);
  const observedEntry = useResizeObserver(ref.current?.parentElement);

  // If the table is wider than the viewport, we want to limit the width of the add row
  // so that it doesn't overflow the viewport.
  // We also subtract the right gap to account for the sticky right gap
  // that is used to keep the add row aligned with the table.
  // If the table is not wider than the viewport, we don't limit the width.

  const widthInView =
    observedEntry?.contentRect.width && fullTableWidth
      ? Math.min(observedEntry.contentRect.width, fullTableWidth) - rightGap
      : undefined;

  return (
    <>
      <Link
        ref={ref}
        to={generatePath(`${pathname}${ACCOUNT_ROUTES.details}`, {
          accountId: "new",
        })}
        style={{ width: widthInView, gridColumn: `1 / -${hasActions ? 2 : 1}` }}
        className="tw-sticky tw-left-0 tw-top-9 tw-col-[1/-2] tw-box-border tw-flex tw-h-8  tw-items-center tw-rounded tw-border tw-border-solid tw-border-primary-300 tw-bg-neutral-25 tw-p-2.5 tw-text-xs tw-font-semibold tw-text-neutral-300 tw-transition-colors hover:tw-bg-primary-300 hover:tw-text-neutral-25 focus:tw-bg-primary-300 focus:tw-text-neutral-25"
      >
        {children}
      </Link>
      {hasActions && <AddRowRightGap />}
    </>
  );
}
